import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type DropdownMenuSeparatorProps = ComponentProps<typeof DropdownMenuPrimitive.Separator>;

export const Separator = ({ ref, className, ...props }: DropdownMenuSeparatorProps) => (
  <DropdownMenuPrimitive.Separator ref={ref} className={cn("h-px shrink-0 bg-neutral-96", className)} {...props} />
);

Separator.displayName = DropdownMenuPrimitive.Separator.displayName;
